// deps
import { useCallback, useContext } from "react";

// internal deps
import { AnalyticsContext } from "@swiggy-private/checkout-core";

// analytics
import { impressionNudgePayFlipkartCoins } from "@payment-client/analytics/events/Payment";

const useFlipkartCoins = (isPaymentsPage: boolean): (() => void) => {
    const { impressionEvent } = useContext(AnalyticsContext);

    const onFlipkartToolTipShow = useCallback(() => {
        impressionNudgePayFlipkartCoins(isPaymentsPage, impressionEvent);
    }, [impressionEvent, isPaymentsPage]);

    return onFlipkartToolTipShow;
};

export default useFlipkartCoins;
